module.exports = __webpack_public_path__ + "fb7bf749c857ab5c738dde57e4beb987.svg";